<label
  *ngIf="label != null && label != '' && showLabel"
  class="sumax-label mb-0 p-0"
  >{{ label
  }}<span *ngIf="required" [class.text-danger]="controls?.errors != null">
    *</span
  ></label
>

<div
  [class.input-icon]="
    controls?.errors != null &&
    (controls?.dirty || controls?.touched) &&
    submitted
  "
  [class.right]="
    controls?.errors != null &&
    (controls?.dirty || controls?.touched) &&
    submitted
  "
>
  <tooltip-message
    [label]="label"
    [controls]="controls"
    [validatorMessage]="validatorMessage"
    [submitted]="submitted"
    [tooltipMessage]="tooltipMessage"
  ></tooltip-message>

  <div class="d-flex">
    <div class="w-100">
      <input
        *ngIf="inputMask != null"
        #inputText
        type="text"
        class="form-control form-control-sm"
        [class.text-uppercase]="format === 'M'"
        [class.text-lowercase]="format === 'm'"
        [class.text-right]="textRight"
        [autocomplete]="autocomplete"
        [placeholder]="placeholder"
        [class.is-invalid]="
          controls?.errors != null &&
          (controls?.dirty || controls?.touched) &&
          submitted
        "
        [disabled]="disabled"
        [readonly]="readonly"
        [mask]="inputMask"
        [patterns]="patterns"
        (blur)="onBlur($any($event.target).value)"
        (input)="onInput($any($event.target).value)"
        (focusout)="onFocusOut($any($event.target).value)"
        (focus)="onFocus($any($event.target).value)"
        (keyup.enter)="enterKeyUp()"
        (keyup.ArrowUp)="arrowUpKeyUp()"
        [ngClass]="setNgClass"
        [(ngModel)]="value"
        [class.bold]="bold"
      />
      <input
        *ngIf="inputMask == null"
        #inputText
        type="text"
        class="form-control form-control-sm"
        [class.text-uppercase]="format === 'M'"
        [class.text-lowercase]="format === 'm'"
        [class.text-right]="textRight"
        [autocomplete]="autocomplete"
        [placeholder]="placeholder"
        [class.is-invalid]="
          controls?.errors != null &&
          (controls?.dirty || controls?.touched) &&
          submitted
        "
        [disabled]="disabled"
        [readonly]="readonly"
        [attr.maxLength]="maxLength"
        (blur)="onBlur($any($event.target).value)"
        (input)="onInput($any($event.target).value)"
        (focusout)="onFocusOut($any($event.target).value)"
        (focus)="onFocus($any($event.target).value)"
        (keyup.enter)="enterKeyUp()"
        (keyup.ArrowUp)="arrowUpKeyUp()"
        [ngClass]="setNgClass"
        [(ngModel)]="value"
        [class.bold]="bold"
      />
    </div>
    <div class="bd-highlight" *ngIf="btnEnable">
      <button
        type="button"
        class="btn btn-info p-0 rounded-0 h-100"
        (click)="clickEnable()"
      >
        <i
          class="fa fa-check text-white px-1"
          [matTooltip]="'Habilitar'"
          matTooltipClass="bg-info"
        ></i>
      </button>
    </div>
  </div>
</div>
<error-message
  [label]="label"
  [controls]="controls"
  [validatorMessage]="validatorMessage"
  [submitted]="submitted"
  [tooltipMessage]="tooltipMessage"
></error-message>
